define('drops/stack/stack',[
    'jquery',
    'underscore',
    'when',
    'lq/drop',
    'lq/style',
    'lq/onlongpress',
], function ($, _, when, Drop, Style, OnLongPress) {
    'use strict';

    var defaults = {
        data: {
            orientation: 'vertical',
            childIdsByPosition: [],
            useDynamicWidth: true,
            useDynamicHeight: true,
            isDynamiclySizedContainer: true
        }
    };

    var base = Drop;

    var Stack = function (options) {
        Drop.call(this, $('<div/>'), defaults, options);
        var self = this;

        this.$element
            .addClass('boxToBorderSize stacklayout has-states');

        self.determineAutoLayout();

        Style.renderStyles(this);
    };

    Drop.extend(Stack);

    Stack.typeName = 'Stack';

    Stack.prototype.determineAutoLayout = function() {
        if (this.data.orientation === 'vertical') {
            this.data.autoHeight = true;
            this.data.autoWidth = false;
            this.$element
                .removeClass('horizontal')
                .removeClass('continuous')
                .addClass('vertical');
        }

        if (this.data.orientation === 'horizontal') {
            this.data.autoHeight = false;
            this.data.autoWidth = true;
            this.$element
                .removeClass('vertical')
                .removeClass('continuous')
                .addClass('horizontal');
        }

        if (this.data.orientation === 'continuous') {
            this.data.autoHeight = true;
            this.data.autoWidth = false;
            this.$element
                .removeClass('vertical')
                .removeClass('horizontal')
                .addClass('continuous')
                .css({
                    justifyContent: this.data.contentAlignment ?? 'flex-start'
                });
        }
    };

    Stack.prototype.applyPositionForChild = function (childDrop) {
        this.resetPositioningForChild(childDrop);

        if (childDrop.applyRelativePositioning)
            childDrop.applyRelativePositioning();

        childDrop.$wrapper.css(this.getPositionCss(childDrop.data));

        var sizeCss = {};

        if (this.shouldStretchHorizontally() || childDrop.data.useDynamicWidth || childDrop.data.autoWidth) {
            sizeCss.width = 'auto';
        } else {
            sizeCss.width = childDrop.data.size.x + 'px';
        }

        if (!childDrop.data.useDynamicHeight && !childDrop.data.autoHeight) {
            sizeCss.height = childDrop.data.size.y + 'px';
        } else {
            sizeCss.height = 'auto';
        }

        childDrop.$element.css(sizeCss);
    };

    Stack.prototype.getChildElementForVisibility = function (childDrop) {
        return childDrop.$wrapper;
    };

    Stack.prototype.resetPositioningForChild = function(childDrop) {
        childDrop.$element.css({
            left: 'auto',
            right: 'auto',
            top: 'auto',
            bottom: 'auto',
            position: 'relative'
        });
    };

    Stack.prototype.shouldStretchHorizontally = function () {
        return this.data.orientation === 'vertical'
            && this.data.right !== null && this.data.right !== undefined
            && this.data.left !== null && this.data.left !== undefined;
    };

    Stack.prototype.isDropAnchoredLeftAndRight = function (drop) {
        return drop.data.right !== null && drop.data.right !== undefined
            && drop.data.left !== null && drop.data.left !== undefined;
    };

    Stack.prototype.getPositionCss = function(data) { //Gets position-css for a childDrop
        var css = {
            zIndex: data.zIndex
        };

        if (this.data.orientation === 'vertical') {
            this.applyHorizontalAlignmentCss(css, data);
        } else {
            this.applyVerticalAlignmentCss(css, data);
        }

        css.paddingLeft = 0;
        css.paddingRight = 0;
        css.paddingTop = 0;
        css.paddingBottom = 0;

        if (data.margin) {
            if (data.margin.left)
                css.paddingLeft = data.margin.left + "px";
            if (data.margin.right)
                css.paddingRight = data.margin.right + "px";
            if (data.margin.top)
                css.paddingTop = data.margin.top + "px";
            if (data.margin.bottom)
                css.paddingBottom = data.margin.bottom + "px";
        }

        return css;
    };

    Stack.prototype.applyVerticalAlignmentCss = function (css, data) {
        css.verticalAlign = 'top';

        if (data.stack_verticalAlignment) {
            if (data.stack_verticalAlignment === "bottom") {
                css.verticalAlign = 'bottom';
            } else if (data.stack_verticalAlignment === "center") {
                css.verticalAlign = 'middle';
            }
        }
    };

    Stack.prototype.applyHorizontalAlignmentCss = function (css, data) {
        css.marginLeft = 'initial';
        css.marginRight = 'initial';

        if (this.shouldStretchHorizontally()) {
            css.width = '100%';
        } else if (data.stack_horizontalAlignment) {
            if (data.stack_horizontalAlignment === "right") {
                css.marginLeft = 'auto';
            } else if (data.stack_horizontalAlignment === "center") {
                css.marginLeft = 'auto';
                css.marginRight = 'auto';
            }
        }
    };

    Stack.prototype.preRender = function () {
        this.piping.visibility.apply(this);

        // if the stack is the only drop in a list item => switch to relative positioning
        if ((this.parent.data.type === 'ListItem' || (this.parent.data.type === 'ModalPopup' && this.parent.data.autoPosition)) && this.parent.childDrops.length === 1) {
            var elementCss = {
                position: 'relative',
                inset: ''
            };
            this.data.positioning = 'relative';
            this.data.position = {x: 0, y: 0};

            var parentElementCss = {
            };

            if (this.data.useDynamicWidth) {
                elementCss.width = 'auto';
                parentElementCss.width = 'auto';
            }

            if (this.data.useDynamicHeight) {
                elementCss.height = 'auto';
                parentElementCss.height = 'auto';
            }

            this.$element.css(elementCss);
            this.parent.$element.css(parentElementCss);

            this.parent.applyPositionForChild(this);
            if (!this.data.useDynamicWidth && this.shouldStretchHorizontally()) {
                // Correction after applyPositionForChild()
                // This is a special case where we want to anchor a stack which
                // DOES NOT have dynamic width but still makes it's parent strech horizontally
                // in this case the anchoring acts like a margin, which we can confidently
                // apply since we know that's to only element in it's container
                this.$element.css({
                    inset: '',
                    margin: this.$element.css('inset')
                });
            }
        } else {
            this.data.positioning = 'absolute';
            this.applyPosition();
        }

        if (this.isEventEnabled('clicked')) {
            new OnLongPress().applyLongPressOnElement(this.$element, this);
            this.$element.addClass('clickable');
        }
    };

    Stack.prototype.render = function ($element) {
        return this.createAndRenderDrops($element);
    };

    Stack.prototype.postRender = function () {
        if (this.data.centered && this.data.useDynamicWidth) {
            this.applyCentering();
        }
    };

    Stack.prototype.applyCentering = function () {
        this.$element.css({
            width: 'fit-content'
        });
    };

    Stack.prototype.addDrop = function (drop) {
        var $wrapper = $('<div/>')
            .addClass('stack-child');

        drop.$wrapper = $wrapper;
        return base.prototype.addDrop.apply(this, arguments);
    };

    Stack.prototype.createRenderPromisesForChildren = function (drops) {
        var self = this;
        var renderPromises = [];
        var repositionedDrops = [];
        _.each(this.data.childIdsByPosition, function(dropId) {
            var drop = _.find(drops, function(drop) { return drop.data.id === dropId; });
            if (drop) {
                repositionedDrops.push(drop);
            }
        });

        //add drops that are somehow missing from the 'childIdsByPosition' array to the end of the stack
        _.each(drops, function (drop) {
            var foundDrop = _.find(repositionedDrops, function (repositionedDrop) { return repositionedDrop.data.id === drop.data.id; });
            if (!foundDrop) {
                repositionedDrops.push(drop);
            }
        });

        _.each(repositionedDrops, function (drop) {
            self.addDrop(drop);
            renderPromises.push(self.createRenderPromiseForChild(drop));
        });

        return renderPromises;
    };

    Stack.prototype.createRenderPromiseForChild = function (drop) {
        var self = this;

        return when()
            .then(function () {
                if (drop.isHidden) { //parent is not yet set in constructor when calling the visibility stuff, correcting visibility here
                    drop.$wrapper.addClass('drop-hidden');
                    drop.$element.removeClass('drop-hidden');
                }

                drop.$wrapper.appendTo(self.$element);
                if (!self.data.useDynamicWidth && self.isDropAnchoredLeftAndRight(drop)) {
                    drop.$element.css({
                        inset: '',
                        marginLeft: drop.data.left + 'px',
                        marginRight: drop.data.right + 'px'
                    });
                }
                return drop.render(drop.$wrapper)
            });
    };

    Stack.prototype.getStates = function () {
        return [
            { key: 'normal', value: 'Normal' },
            { key: 'hover', value: 'Hover' },
        ];
    };

    return Stack;
});


